import * as Sentry from '@sentry/react'
import {
  useEffect,
} from 'react'
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom'

Sentry.init({
  dsn: "https://5d0b745f7a20f60026d3473d8d12ae19@o4510993899126784.ingest.de.sentry.io/4510993914200144",
  tunnel: `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/sentry-tunnel`,
  release: import.meta.env.VITE_APP_RELEASE || import.meta.env.VITE_COMMIT_SHA || import.meta.env.MODE,
  sendDefaultPii: true,
  debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.5,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
})
